/**
 * @generated SignedSource<<21df87bacad2b98cc58beb2c0cc22f32>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SchoolExamSourcePublishDifferenceCounterLabel_difference$data = {
  readonly scrapImages?: ReadonlyArray<{
    readonly __typename: "Diff";
  }> | null;
  readonly " $fragmentType": "SchoolExamSourcePublishDifferenceCounterLabel_difference";
};
export type SchoolExamSourcePublishDifferenceCounterLabel_difference$key = {
  readonly " $data"?: SchoolExamSourcePublishDifferenceCounterLabel_difference$data;
  readonly " $fragmentSpreads": FragmentRefs<"SchoolExamSourcePublishDifferenceCounterLabel_difference">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SchoolExamSourcePublishDifferenceCounterLabel_difference",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Diff",
          "kind": "LinkedField",
          "name": "scrapImages",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "SchoolExamSourcePublishDifference",
      "abstractKey": null
    }
  ],
  "type": "Difference",
  "abstractKey": "__isDifference"
};

(node as any).hash = "cc8ed85fecdf233374df7d10387c05ca";

export default node;
